import { configService, fullInfoService } from 'services/domain'
import { notificationMeService } from 'services/notifications'
import { postRegisterSystemAccess } from 'services/user'
import { setI18nLang } from 'support/i18n'
import AnalyticsService from 'support/analytics'

export const initialLoadActionConditional = () => (dispatch, getState) => {
  const { currentDomain, dataLoaded, dataLoading } = getState().data.domain
  // const { globalIsHackthon } = getState().data.domain.config
  // console.log("🚀 ~ initialLoadActionConditional ~ globalIsHackthon: on change toggle",  globalIsHackthon)

  const onSuccess = response => {
    // TEMP TRACE (route authorization timing) - remove once verified
    console.log('[route-auth] 5. fullInfoService complete', {
      admin: response.admin,
      isInnovator: response.isInnovator,
    })
    setI18nLang(response.domainConfiguration.lang, dispatch)
    dispatch(postRegisterSystemAccess())
    AnalyticsService.initialise(response.domainConfiguration.gaTrackId)
  }

  if (!dataLoaded && !dataLoading && currentDomain ) {
    // TEMP TRACE (route authorization timing) - remove once verified
    console.log('[route-auth] 4. dispatching fullInfoService', { currentDomain })
    dispatch(fullInfoService(onSuccess))
    dispatch(configService())
    dispatch(notificationMeService())
  } else if (!dataLoaded) {
    // TEMP TRACE - if the loader ever sticks, this tells you why the fetch was skipped.
    // Guarded on !dataLoaded because this thunk re-runs on every DataInitializer render.
    console.log('[route-auth] 4. fullInfoService skipped', {
      dataLoaded,
      dataLoading,
      currentDomain,
    })
  }
}